var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmail24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7A1.5 1.5 0 015 5.5h14A1.5 1.5 0 0120.5 7v10a1.5 1.5 0 01-1.5 1.5H5A1.5 1.5 0 013.5 17V7zM5 6.5a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h14a.5.5 0 00.5-.5V7a.5.5 0 00-.5-.5H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61 8.689a.5.5 0 01.702-.078L12 12.361l4.688-3.75a.5.5 0 11.624.78l-5 4a.5.5 0 01-.624 0l-5-4a.5.5 0 01-.078-.702z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 11.277a.5.5 0 01.039.707l-3 3.35a.5.5 0 01-.745-.668l3-3.35a.5.5 0 01.706-.039zm3.332 0a.5.5 0 01.707.04l3 3.35a.5.5 0 01-.745.667l-3-3.35a.5.5 0 01.038-.707z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail24);
export default __webpack_public_path__ + "static/media/icon-email-24.48c7d576.svg";
export { ForwardRef as ReactComponent };